import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import navigateToURL from 'lib/navigateToURL';
import {agentHomepageUrl} from 'llm/routes/UrlUtils';
import {TeamMembersTeam} from 'orgs/__generated/TeamMembersTeam';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {AgentMembersTable} from './MembersTable';
import {Member, MemberInfo} from './OrganizationConstants';

export default function TeamAgentMembersTab({
  team,
  teamAgentMembers,
  isCurrentUserMember,
  userIdToMemberInfo,
}: {
  team: TeamMembersTeam;
  teamAgentMembers?: Array<Member>;
  isCurrentUserMember: boolean;
  userIdToMemberInfo: {[userId: string]: MemberInfo} | null;
}): JSX.Element {
  if (!teamAgentMembers || !userIdToMemberInfo) {
    return <CenteredHorizontalThrobber />;
  }

  if (teamAgentMembers.length === 0) {
    return <div>No agents yet.</div>;
  }

  const canManageRoles = team.permissions.canManageRoles ?? false;
  return (
    <AgentMembersTable
      groupId={team.id}
      groupType={ModelTypeConstants.TEAM}
      canManageRoles={canManageRoles}
      members={teamAgentMembers}
      shouldShowMemberInfo={isCurrentUserMember || canManageRoles}
      userIdToMemberInfo={userIdToMemberInfo}
      onRowClick={({id}) => {
        navigateToURL(agentHomepageUrl(id));
      }}
    />
  );
}
